<div class="user-progress">
    <div class="user-progress-progress mb-56">
        <div *ngIf="teamService.userProgress$ | async; let userProgress">
            <div
                *ngIf="
                    userProgress.charts.length ||
                        isCertificateMgmtFeatureEnabled ||
                        isGradebookFeatureEnabled ||
                        isCertificateOfAttendanceFeatureEnabled ||
                        approvalRequestsTeamOverview ||
                        performanceTeamMemberOverviews.length ||
                        (isToDoFeatureEnabled && userToDoStatistics) ||
                        bookingsTeamOverview;
                    else noProgress
                "
            >
                <div fxLayout="row wrap" fxLayoutAlign="flex-start space-between" fxLayoutGap.gt-xs="8px grid">
                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0"
                    >
                        <app-course-completion class="w-100-p" [charts]="userProgress.charts"></app-course-completion>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0"
                    >
                        <app-monthly-active-days class="w-100-p" [charts]="userProgress.charts" [yearlyActiveDays]="userProgress.yearlyActiveDays"></app-monthly-active-days>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0"
                    >
                        <app-total-learning-time class="w-100-p" [horizontalView]="false" [totalLearningTime]="userProgress.totalLearningTime"></app-total-learning-time>
                    </mat-card>

                    <mat-card
                        appearance="outlined"
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0 pointer"
                        (click)="openTeamCertificatesDialog()"
                        *ngIf="(isCertificateMgmtFeatureEnabled || isGradebookFeatureEnabled || isCertificateOfAttendanceFeatureEnabled) && canViewCertificates"
                    >
                        <app-team-certificates
                            class="w-100-p"
                            [horizontalView]="false"
                            [totalCount]="userProgress.certificateStats.totalCount"
                            [expiredCount]="userProgress.certificateStats.expiredCount"
                        ></app-team-certificates>
                    </mat-card>

                    <mat-card
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        appearance="outlined"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0 pointer"
                        *ngIf="bookingsTeamOverview && canViewBookings"
                    >
                        <app-team-bookings class="w-100-p" [bookingsTeamOverview]="bookingsTeamOverview" [teamId]="team.id" [teamMemberId]="memberId"></app-team-bookings>
                    </mat-card>

                    <mat-card
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        appearance="outlined"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0 pointer"
                        *ngIf="approvalRequestsTeamOverview && canViewApprovalRequests"
                    >
                        <app-team-approval-requests
                            class="w-100-p"
                            [approvalRequestsTeamOverview]="approvalRequestsTeamOverview"
                            [teamId]="team.id"
                            [teamMemberId]="memberId"
                        ></app-team-approval-requests>
                    </mat-card>

                    <mat-card
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        appearance="outlined"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0"
                        *ngIf="performanceTeamMemberOverviews.length"
                    >
                        <app-performance-team-member-review
                            class="w-100-p"
                            [performanceTeamMemberOverviews]="performanceTeamMemberOverviews"
                            [teamId]="team.id"
                            [memberId]="memberId"
                        ></app-performance-team-member-review>
                    </mat-card>

                    <mat-card
                        fxLayout="row"
                        fxLayoutAlign="flex-start space-between"
                        appearance="outlined"
                        fxFlex="1 0 calc(100%-8px)"
                        fxFlex.gt-xs="1 0 calc(50%-8px)"
                        fxFlex.gt-md="1 0 calc(33.33%-8px)"
                        class="mb-12 p-0 user-progress-progress-card-container mat-elevation-z0"
                        *ngIf="isToDoFeatureEnabled && userToDoStatistics && canViewTodos"
                    >
                        <app-user-todos class="w-100-p" [userToDoStatistics]="userToDoStatistics" [teamId]="team.id" [memberId]="memberId"></app-user-todos>
                    </mat-card>
                </div>

                <ng-template #noProgress>
                    <div fxLayout="column" fxLayoutAlign="center center" class="no-user-progress-container p-32">
                        <mat-icon class="participant-view-illustration" svgIcon="team_progress_illustration"></mat-icon>
                        <h3 class="mt-8 mb-4">
                            {{ 'TEAMS.MEMBER_PROGRESS.LABEL.NO_BOOKED_COURSES' | translate }}
                        </h3>
                        <p class="mt-0 mb-16">
                            {{ 'TEAMS.MEMBER_PROGRESS.LABEL.GET_IN_TOUCH' | translate }}
                        </p>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
